<div class="ips-container">
  <div class="ips-container__thumb"></div>
  <int-spin-loader [color]="loaderColor" size="2em" class="loader"></int-spin-loader>
</div>
